import { Toaster as Sonner, toast } from "sonner";

export type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[hsl(var(--paper))] group-[.toaster]:text-[hsl(var(--primary))] group-[.toaster]:border-2 group-[.toaster]:border-[hsl(var(--paper-edge))] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[hsl(var(--muted-foreground))]",
          actionButton: "group-[.toast]:bg-[hsl(var(--primary))] group-[.toast]:text-[hsl(var(--primary-foreground))]",
          cancelButton: "group-[.toast]:bg-[hsl(var(--secondary))] group-[.toast]:text-[hsl(var(--secondary-foreground))]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
